import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-convocatorias',
  templateUrl: './convocatorias.component.html',
  styleUrls: ['./convocatorias.component.css']
})
export class ConvocatoriasComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
